import { render, staticRenderFns } from "./not-a-ticket.vue?vue&type=template&id=18b13a61&scoped=true"
import script from "./not-a-ticket.vue?vue&type=script&lang=js"
export * from "./not-a-ticket.vue?vue&type=script&lang=js"
import style0 from "./not-a-ticket.vue?vue&type=style&index=0&id=18b13a61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b13a61",
  null
  
)

export default component.exports